import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import {
  applicationStatusSubscriptionsStateForJobIdSelector,
  applicationStatusSubscriptionsStateForOrgIdSelector,
} from '../application-status-subscription-selector';

import { get } from '../../api/api';

export const loadApplicationStatusSubscriptions = ({ jobId, orgId }: OneIdAllowedConstraint) =>
  createGenericDispatcher<ApplicationStatusSubscription[]>({
    name: 'LOAD_APPLICATION_STATUS_SUBSCRIPTIONS',
    loadFunction: () =>
      get(`/application-status-subscription?${jobId ? `jobId=${jobId}` : `orgId=${orgId}`}`),
    args: { jobId, orgId },
    shouldExecuteSelector: (state: any) => {
      if (typeof jobId === 'number') {
        return applicationStatusSubscriptionsStateForJobIdSelector(state, jobId);
      }
      return applicationStatusSubscriptionsStateForOrgIdSelector(state, orgId);
    },
  });
